import { Mutation } from 'vuex';
import { IModuleState } from './types';

// 列表
export const setMatSuppliers: Mutation<IModuleState> = (state, payload) => {
  state.list.data = payload.data;
  state.list.loading = !!payload.loading;
};

// 供应商列表
export const setMatOrgs: Mutation<IModuleState> = (state, payload) => {
  state.orgs.data = payload.data;
  state.orgs.pageNum = payload.pageNum;
  state.orgs.pageSize = payload.pageSize;
  state.orgs.total = payload.total;
  state.orgs.loading = !!payload.loading;
};

// 已保存的组织列表（灯具）
export const setSavedOrgs: Mutation<IModuleState> = (state, payload) => {
  state.savedOrgs.data = payload.data;
  state.savedOrgs.loading = !!payload.loading;
};

// 编辑弹窗
export const setDialog: Mutation<IModuleState> = (state, payload) => {
  state.dialog.type = payload.type;
  state.dialog.title = payload.title;
  state.dialog.data = payload.data;
  state.dialog.visible = !!payload.visible;
  state.dialog.loading = !!payload.loading;
};

// confirm 弹窗
export const setConfirm: Mutation<IModuleState> = (state, payload) => {
  state.confirm.title = payload.title;
  state.confirm.content = payload.content;
  state.confirm.visible = !!payload.visible;
  state.confirm.loading = !!payload.loading;
};

export const setLoading: Mutation<IModuleState> = (state, payload) => {
  state.loading = payload;
};
